import { RoomItem } from "./RoomItem";
import { UserSimplified } from "./User";
import { DocumentLoader } from "./local/Types";

export type DataSourceType = 'officenote-page' | 'file-bot-upload' | 'room-item' | 'source-doc';

export class BaseSource {
  static SUBCOL = 'sources'; // soribots/sources
  public grounded: Date | null = null; // when the source was first added to knowledge base.
  public updated = new Date();
  public created = new Date();
  public noParts?: number; // = nr of chunks
  public error?: string;
  constructor(public id: string, public soribotId: string, public type: DataSourceType, public creatorId: string, public title: string) {
  }
}

export class SourceOfficeNotePage extends BaseSource {
  constructor(
    soribotId: string,
    creatorId: string,
    public pageId: string,
    pageTitle: string,
    public pageUpdated: Date | null
  ) {
    super(`${soribotId}_${pageId}`, soribotId, 'officenote-page', creatorId, pageTitle);
  }
}

export class SourceUploadedFile extends BaseSource {
  constructor(soribotId: string, creatorId: string, public fileName: string,
    public fileUrl: string, public fileSize: number, public fileType: string) {
    super(`${soribotId}_${fileName}`, soribotId, 'file-bot-upload', creatorId, fileName);
  }
}

export class SourceRoomItem extends BaseSource {
  constructor(soribotId: string, creatorId: string, public item: RoomItem, public roomName: string) {
    super(`${soribotId}_${item.id}`, soribotId, 'room-item', creatorId, item.title ?? "no title");
  }
}

// SourceDocument contains the actual text unlike the other source classes, which refer to a second data object.
// AKA Knowledge Document in UI.
export class SourceDocument extends BaseSource {
  public chunks: string[] = [];
  public metadata?: string;
  public chunkSize: number = 1000;
  public chunkOverlap: number = 0;
  public divider: string | null = null;

  public sourceFileUrl: string | null = null;   // Source documents can be created from uploaded PDF files.
  public sourceFileName: string | null = null;
  public sourceDocLoader?: DocumentLoader;

  public forUser: UserSimplified | null = null; // Source documents can store message history for a specific user.
  public inProgress: boolean = false;

  constructor(
    id: string,
    soribotId: string,
    creatorId: string,
    title: string
  ) {
    super(id, soribotId, 'source-doc', creatorId, title);
  }

  static getSuggestionDocId(soribotId: string): string {
    return `suggestions-${soribotId}`;
  }
}

